import { RoleType } from './Field';
import { BField, FieldType } from './Field';
import { FormType } from './Formula';
import { FFuncType } from './Formula/FormulaFunc';
export class CalcField extends BField {
    constructor(formula, varType) {
        super();
        this._formula = formula;
        this._varType = varType;
    }
    get formula() {
        return this._formula;
    }
    get roleType() {
        switch (this.formula.expr.type) {
            case 'AGG':
                return RoleType.MEASURE;
            case 'SCALAR':
                return RoleType.DIMENSION;
        }
    }
    get varType() {
        return this._varType;
    }
}
export class ModelCalcField extends CalcField {
    constructor(name, formula, dataType, varType) {
        super(formula, varType);
        this._name = name;
        this._dataType = dataType;
    }
    get name() {
        return this._name;
    }
    get type() {
        return FieldType.MODELCALC;
    }
    get dataType() {
        return this._dataType;
    }
}
export class ViewCalcField extends CalcField {
    constructor(formula, varType, id, sid) {
        super(formula, varType);
        this._id = id;
        this._sid = sid || 0;
    }
    get id() {
        return this._id;
    }
    get sid() {
        return this._sid;
    }
    get psid() {
        return `00${this.sid}`.slice(-2);
    }
    get alias() {
        if (this.sid) {
            return `f-${this.psid}-${this.id}`;
        }
        else {
            return this.id;
        }
    }
    get name() {
        return this.getFormattedName();
    }
    get source() {
        return this.formula.source;
    }
    get type() {
        return FieldType.VIEWCALC;
    }
    get dataType() {
        return this.formula.expr.returnType;
    }
    getFormattedName() {
        switch (this.formula.form) {
            case FormType.AGGFUNC: {
                const agg = this.formula;
                return `${agg.funcName}(${agg.fieldName})`;
            }
            case FormType.DATEFUNC: {
                const date = this.formula;
                return `${date.datePart.toUpperCase()}(${date.fieldName})`;
            }
            case FormType.FIELD: {
                const field = this.formula;
                return field.fieldName;
            }
            case FormType.GENERIC: {
                if (this.formula.expr.type === FFuncType.SCALAR) {
                    return this.formula.source;
                }
                else {
                    return `AGG(${this.formula.source})`;
                }
            }
            case FormType.NTILEFUNC: {
                const ntile = this.formula;
                return `${ntile.funcName}${ntile.percentile * 100}(${ntile.fieldName})`;
            }
        }
    }
}
